<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <div class="md:tw-w-1/4">
              <!-- currentOrganization -->
              <form-field
                label="common.currentOrganization"
                [control]="form?.get('currentOrganization')"
                [value]="permissionService.userState()?.organizationName"
              >
              </form-field>
            </div>

            <!-- getterOrganizationId -->
            <div class="md:tw-w-1/4">
              <!-- getterOrganization -->
              <organization-select-search
                label="common.getterOrganization"
                type="descendantList"
                [isDisabled]="formPageConfig.isEditMode"
                [control]="form?.get('getterOrganizationId')"
                [removable]="inputOrganizationId ? false : true"
                [value]="inputOrganizationId || model.getterOrganizationId"
                (valueChange)="
                  model.getterOrganizationId = $event; model.getterUserId = null
                "
                (onError)="onClose()"
              >
              </organization-select-search>
            </div>

            <!-- getterUserId -->
            <div class="md:tw-w-1/4">
              <users-select-search
                label="common.getterUser"
                type="usersListByOrganizationId"
                [control]="form?.get('getterUserId')"
                [id]="inputOrganizationId || model.getterOrganizationId"
                [(value)]="model.getterUserId"
                (onError)="onClose()"
                [isDisabled]="
                  model.getterOrganizationId || inputOrganizationId
                    ? false
                    : true
                "
              >
              </users-select-search>
            </div>

            <!-- TypeTransactions -->
            <div class="md:tw-w-1/4">
              <enum-select-search
                class="tw-w-full"
                enumName="TypeTransactions"
                [label]="fields + 'typeTransaction'"
                [control]="form?.get('typeTransaction')"
                [(value)]="model.typeTransaction"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- amount -->
            <div class="md:tw-w-1/4">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('amount')"
                [(value)]="model.amount"
                [hasCurrency]="true"
                [label]="'common.amount'"
              >
              </form-field>
            </div>

            <!-- typeCreditChange -->
            <div class="md:tw-w-1/4">
              <enum-select-search
                class="tw-w-full"
                enumName="TypeCreditChanges"
                [label]="fields + 'typeCreditChange'"
                [control]="form?.get('typeCreditChange')"
                [(value)]="model.typeCreditChange"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- description -->
            <div class="md:tw-w-1/2">
              <form-textarea
              class="tw-w-full font-vazir-ui"
              label="common.description"
              [(value)]="model.description"
              [control]="form?.get('description')"
              [rows]="1"
              maxlength="100"
            >
            </form-textarea>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
